import type { SiteConfigDownloadPage, SiteLocalizedText } from '../types';

export const DEFAULT_DOWNLOAD_PAGE: SiteConfigDownloadPage = {
    freeBadge: { en: 'FREE', 'pt-BR': 'GRÁTIS' },
    title: { en: 'DOWNLOAD THE GAME NOW', 'pt-BR': 'BAIXE O JOGO AGORA' },
    subtitle: { en: 'Knight Icarus Online Client', 'pt-BR': 'Cliente Knight Icarus Online' },
    clientDesc: {
        en: 'A next-generation graphics and performance experience. Choose an option below.',
        'pt-BR': 'Experiência de gráficos e desempenho de próxima geração. Escolha uma opção abaixo.',
    },
    defaultButtonText: {
        en: 'DOWNLOAD GAME - Knight Icarus Online',
        'pt-BR': 'BAIXAR JOGO - Knight Icarus Online',
    },
    systemRequirementsTitle: { en: 'SYSTEM REQUIREMENTS', 'pt-BR': 'REQUISITOS DO SISTEMA' },
    systemRequirementsNote: {
        en: 'Requires a 64-bit processor and operating system.',
        'pt-BR': 'Requer processador e sistema operacional de 64 bits.',
    },
};

export function mergeDownloadPageConfig(fromApi?: SiteConfigDownloadPage): SiteConfigDownloadPage {
    const keys = Object.keys(DEFAULT_DOWNLOAD_PAGE) as (keyof SiteConfigDownloadPage)[];
    const merged: SiteConfigDownloadPage = {};
    for (const key of keys) {
        merged[key] = {
            ...DEFAULT_DOWNLOAD_PAGE[key],
            ...fromApi?.[key],
        };
    }
    return merged;
}

export function pickLocalizedText(
    block: SiteLocalizedText | undefined,
    locale: 'en' | 'pt-BR',
    fallback: string
): string {
    if (block?.[locale]?.trim()) return block[locale]!.trim();
    if (block?.en?.trim()) return block.en.trim();
    if (block?.['pt-BR']?.trim()) return block['pt-BR']!.trim();
    return fallback;
}
